<template>
  <div class="zoomable-wrapper" @click="toogleZoom" :class="{ 'zoomed': zoom }">
    <div class="img-wrapper">
      <img class="close-btn" src="../assets/icons/croix.svg" v-if="zoom">
      <slot></slot>
    </div>
    <p v-show="!zoom" class="annotation">Cliquez sur l'image pour l'agrandir</p>
  </div>
</template>

<script>
export default {
  name: 'ZommableImage',
  data () {
    return {
      zoom: false
    }
  },
  methods: {
    toogleZoom () {
      this.zoom = !this.zoom
    }
  }
}
</script>

<style lang="scss">
.zoomable-wrapper {
  cursor: pointer;
  &.zoomed {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 20px;
    .img-wrapper {
      position: relative;
      .close-btn {
        position: absolute;
        top: -40px;
        left: calc(50% - 15px);
      }
      img {
        width: auto;
        height: auto;
      }
    }
  }
  .annotation {
    font-style: italic;
    font-size: 0.9rem;
    color: $secondary-text-color;
  }
}
</style>
